import { Box } from "@chakra-ui/react";
import { Link } from "@components/ui-kit";
import React, { type FC } from "react";
import type { ColumnProps } from ".";

export const Brand: FC<React.PropsWithChildren<ColumnProps>> = ({ row }) => {
  const lastBrand = row.brands[row.brands.length - 1];
  return (
    <div className="flex items-center">
      <Box>
        {row.brands.map((b) => (
          <React.Fragment key={b.id}>
            <Link href={{ pathname: "/brands/detail", query: { id: b.id } }}>
              {b.name}
            </Link>
            {lastBrand.id === b.id ? null : ", "}
          </React.Fragment>
        ))}
      </Box>
    </div>
  );
};
